import script from "./TaskCalendarIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCalendarIndex.vue?vue&type=script&setup=true&lang=js"

import "./TaskCalendarIndex.vue?vue&type=style&index=0&id=3b6f2be0&lang=css"
import "./TaskCalendarIndex.vue?vue&type=style&index=1&id=3b6f2be0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6f2be0"]])

export default __exports__